import { BlockConfigurationObject } from "../../../interfaces/block-configuration-object.interface";
import { BetService } from "../../../services/bet.service";
import { GeneralService } from "../../../services/general.service";
import { MatchService } from "../../../services/match.service";

export class MatchTileController {
	awayBeforeHome = false;

	matchService: MatchService;
	generalService: GeneralService;
	betService: BetService;
	configurationObject: BlockConfigurationObject;

	/* @ngInject */
	constructor(configurationObject: BlockConfigurationObject, matchService: MatchService,
		generalService: GeneralService, betService: BetService) {
		this.matchService = matchService;
		this.generalService = generalService;
		this.betService = betService;
		this.configurationObject = configurationObject;

		if (!configurationObject.matchFirstTeam || configurationObject.matchFirstTeam === "away") {
			this.awayBeforeHome = true;
		}
	}

	
}